import { gql } from 'graphql-request';
import { MagicEventFragment } from '../../events/fragments/MagicEventFragment';

export const MagicJobFragment = gql`
  ${MagicEventFragment}
  fragment MagicJob on MagicJob {
    id
    type
    title
    status
    statusIcon
    statusMessage
    source
    sourceText
    emailSubject
    errorCode
    errorMessage
    createdAt
    updatedAt
    prompt
    toolCallId
    canEdit
    file {
      id
      filename
      mimetype
      url
    }
    files {
      id
      filename
      mimetype
      url
      contentId
    }
    events {
      ...MagicEvent
    }
  }
`;
